import { createBrowserRouter, useLocation } from "react-router-dom";
import HomePage from "@/src/pages/page";
import NotFound from "@/src/components/not-found";
import Nav from "@/src/components/nav";
import { ReactElement, cloneElement, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import Footer from "@/src/components/footer";
import { cn } from "./utils/utils";
import AboutPage from "./pages/about/page";
import ServicePage from "./pages/service/page";
import ExperiencePage from "./pages/experience/page";
import CareersPage from "./pages/careers/page";
import OfficePage from "./pages/office/page";

const PageContainer = (props: {
  children: ReactElement;
  includeNav: boolean;
  includeFooter: boolean;
  snap?: boolean;
}) => {
  const location = useLocation();
  const containerRef = useRef<HTMLDivElement>(null);
  const [yScroll, setYScroll] = useState(0);
  const [yScrollProgress, setYScrollProgress] = useState(0);

  useEffect(() => {
    setYScroll(0);
    setYScrollProgress(0);
  }, [location.pathname]);

  return (
    <>
      <motion.div
        ref={containerRef}
        key={location.pathname}
        id="main-container"
        className={cn(
          "h-dvh hide-scrollbar hide-main-scrollbar overflow-y-scroll overflow-x-hidden",
          props.snap ? "snap-y snap-mandatory" : ""
        )}
        onScroll={() => {
          if (!containerRef.current) return;
          setYScroll(containerRef.current.scrollTop);
          setYScrollProgress(
            containerRef.current.scrollTop / containerRef.current.scrollHeight
          );
        }}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        {props.includeNav && <Nav />}
        {cloneElement(props.children, {
          yScroll: yScroll,
          yScrollProgress: yScrollProgress,
        })}
        {props.includeFooter && <Footer />}
      </motion.div>
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={false}
        children={<HomePage />}
        snap={true}
      />
    ),
    children: [],
  },
  {
    path: "about",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={true}
        children={<AboutPage />}
      />
    ),
  },
  {
    path: "service",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={true}
        children={<ServicePage />}
      />
    ),
  },
  {
    path: "experience",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={true}
        children={<ExperiencePage />}
      />
    ),
  },
  {
    path: "career",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={true}
        children={<CareersPage />}
      />
    ),
  },
  {
    path: "office",
    element: (
      <PageContainer
        includeNav={true}
        includeFooter={true}
        children={<OfficePage />}
      />
    ),
  },
  {
    path: "*",
    element: (
      <PageContainer
        children={<NotFound />}
        includeNav={true}
        includeFooter={true}
      />
    ),
  },
]);

export default router;
